var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-form__input-wrap"},[_c('div',{staticClass:"product-form__title"},[_vm._v(_vm._s(_vm.label))]),_c('Editor',{attrs:{"object":_vm.object,"fieldName":_vm.fieldName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }